var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95966 1.05027C7.35518 0.398209 8.06247 0 8.82511 0C9.58775 0 10.295 0.398209 10.6926 1.05373L16.8586 11.3474C17.2462 12.0188 17.2485 12.8454 16.8646 13.5189C16.4807 14.1924 15.7683 14.6116 14.9851 14.6202L2.65712 14.6201C1.88193 14.6116 1.16948 14.1924 0.785582 13.5189C0.401684 12.8454 0.403998 12.0188 0.79757 11.3374L6.95966 1.05027ZM9.44693 1.80463C9.31509 1.58728 9.07932 1.45455 8.82511 1.45455C8.5709 1.45455 8.33513 1.58728 8.20538 1.80117L2.05128 12.0748C1.92206 12.2985 1.92129 12.5741 2.04926 12.7986C2.17722 13.0231 2.41471 13.1628 2.66511 13.1656L14.9771 13.1657C15.2355 13.1628 15.473 13.0231 15.601 12.7986C15.7289 12.5741 15.7282 12.2985 15.6048 12.0848L9.44693 1.80463ZM8.82511 4.43836C9.1933 4.43836 9.49759 4.71196 9.54574 5.06695L9.55238 5.16563V8.07472C9.55238 8.47639 9.22677 8.802 8.82511 8.802C8.45692 8.802 8.15263 8.52839 8.10448 8.17341L8.09784 8.07472V5.16563C8.09784 4.76397 8.42345 4.43836 8.82511 4.43836ZM9.55966 10.9838C9.55966 10.5822 9.23404 10.2565 8.83238 10.2565L8.72642 10.2632C8.37144 10.3113 8.09784 10.6156 8.09784 10.9838C8.09784 11.3855 8.42345 11.7111 8.83238 11.7111L8.93107 11.7044C9.28605 11.6563 9.55966 11.352 9.55966 10.9838Z",
    fill: "#FF4550"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAlert);
export default __webpack_public_path__ + "static/media/ico_alert.c293013e21b02c1c0ac9649c1cfed68d.svg";
export { ForwardRef as ReactComponent };